/* eslint-disable react/jsx-no-target-blank */
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { batchRequest } from '../../api/ApiService';
import { Loader } from "react-loaders";
import Auth from '../../routes/Auth';
import Teams from '../../api/Teams';
import EventEmitter from '../../services/event-emitter';
import { roleToUrl } from '../../services/utils';

import SmallCheckbox from '../../containers/assets/small-checkbox.png';
import SmallCheckboxActive from '../../containers/assets/small-checkbox-active.png';

import Image1 from '../../containers/assets/next-steps-1.png';
import Image2 from '../../containers/assets/next-steps-2.png';
import Image3 from '../../containers/assets/next-steps-3.png';
import Image4 from '../../containers/assets/next-steps-4.png';
import Image5 from '../../containers/assets/next-steps-4.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;

  .loader {
    display: inline-block;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const Container = styled.div`
  padding: 40px;
  width: 992px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Image = styled.div`
  position: absolute;
  top: -7.5px;
  right: 40px;

  img {
    height: 255px;
  }
`;

const BigGoal = styled.div`
  margin-top: 24px;
  border-radius: 8px;
  background: #fec665;
  padding: 56px 40px 40px 40px;
  position: relative;
  min-height: 240px;
  max-width: 912px;
`;

const BigGoalTitleNum = styled.div`
  width: 32px;
  height: 32px;
  background: #faf5eb;
  border-radius: 4px;
  border: 1px solid #eca427;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  color: #eca427;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const BigGoalTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;

  a:active, a:visited, a:link {
    color: rgba(0, 27, 59, 0.94);
  }

  a:hover {
    text-decoration: underline;
  }
`;

const BigGoalDescription = styled.div`
  margin-top: 4px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  width: calc(100% - 472px);
`;

const CheckboxesRow = styled.div`
  margin-top: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px 19px;
  width: calc(100% - 460px);
  flex-wrap: wrap;
`;

const Checkbox = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  flex-wrap: nowrap;

  a:active, a:visited, a:link {
    font-family: 'Mukta Vaani';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: rgba(0, 27, 59, 0.94);
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

const SmallGoals = styled.div`
  margin-top: 24px;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 24px;
`;

const SmallGoal = styled.div`
  width: 288px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #d5d9dd;
  padding: 16px 16px 48px;
  position: relative;

  ${p => p.isGreyed && `
    opacity: 0.6;
  `}

  img {
    position: absolute;
    right: 16px;
    bottom: 16px;
  }
`;

const SmallGoalTitleNum = styled.div`
  width: 32px;
  height: 32px;
  background: #faf5eb;
  border-radius: 4px;
  border: 1px solid #eca427;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  color: #eca427;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const SmallGoalTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;

  a:active, a:visited, a:link {
    font-family: 'Mukta Vaani';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: rgba(0, 27, 59, 0.94);
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

const SmallGoalDescription = styled.div`
  margin-top: 8px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.6);
`;

class NextStepsPage extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      isBusinessCaseVisited: false,
      isCustomerAnalysisVisited: false,
      isPriorRoundVisited: false,
      isGoalsSubmitted: false,
      isTriviaDone: false,
      userRole: '',
      pdSubmitted: false,
      pmSubmitted: false,
      opSubmitted: false,
      fnSubmitted: false,
      triviaCourseAvailable: 0
    };
    this.eventemitter = EventEmitter.getInstance();
  }

  componentDidMount() {
    const { currentRound, rounds } = this.props;

    const courseId = Number(Auth.getCourseId());
    const gameId = Number(Auth.getGameId());
    const userId = Number(Auth.getUserId());

    this.eventemitter.trigger('next-steps-visited');
    this.props.setMode('basic');

    batchRequest([
      `${process.env.REACT_APP_API_URL}v2/engagement/tracks/?game=${gameId}&course=${courseId}&user=${userId}&round_number=${currentRound}`,
      `${process.env.REACT_APP_API_URL}v2/games/goaltargets/`,
      `${process.env.REACT_APP_API_URL}games/${Auth.getGameId()}/journal/?round_number=${currentRound}`,
      `${process.env.REACT_APP_API_URL}v2/trivia/coursetrivias/`,
      ...(currentRound === 1 ? [] : [
        `${process.env.REACT_APP_API_URL}v2/engagement/tracks/?game=${gameId}&course=${courseId}&user=${userId}&round_number=${currentRound - 1}`
      ]),
      `${process.env.REACT_APP_API_URL}v2/engagement/tracks/?game=${gameId}&course=${courseId}&user=${userId}`
    ])
      .then(res => {
        const currentTeam = Teams.currentTeam();
        const teamId = Number(currentTeam.id);

        const round = rounds.find(i => i.number === currentRound);
        const roundId = round ? Number(round.id) : 0;
        const baseUrl = `${window.location.protocol}//${window.location.host}`;

        const trackedPages = res[0].body;
        const goalsTargets = res[1].body;
        const triviaCourseAvailable = res[3].body.results.length > 0 ? 1 : 0;
        const priorRoundTrackedPages = currentRound === 1 ? [] : res[4].body;

        const trackedPagesForAllRounds = currentRound === 1 ? res[4].body : res[5].body;

        const pages = trackedPages.results
          .filter(i => (
            i.page.indexOf(`${window.location.protocol}//${window.location.host}`) === 0
          ))
          .map(i => i.page.replace(`${window.location.protocol}//${window.location.host}/`, ''))
          .map(i => i.split('?')[0]);

        const pagesForAllRounds = trackedPagesForAllRounds.results
          .filter(i => (
            i.page.indexOf(`${window.location.protocol}//${window.location.host}`) === 0
          ))
          .map(i => i.page.replace(`${window.location.protocol}//${window.location.host}/`, ''))
          .map(i => i.split('?')[0]);
        const priorRoundPages = currentRound === 1 ? [] : priorRoundTrackedPages.results
          .filter(i => (
            Number(i.course) === courseId &&
            Number(i.game) === gameId &&
            Number(i.round_number) === currentRound - 1 &&
            Number(i.user) === userId &&
            i.page.indexOf(baseUrl) === 0
          ))
          .map(i => i.page.replace(`${baseUrl}/`, ''))
          .map(i => i.split('?')[0]);

        const isBusinessCaseVisited = (
          pagesForAllRounds.includes('analysis/bcase/executive-summary')
          && pagesForAllRounds.includes('analysis/bcase/opportunity-economy-industry')
          && pagesForAllRounds.includes('analysis/bcase/market')
          && pagesForAllRounds.includes('analysis/bcase/product')
          && pagesForAllRounds.includes('analysis/bcase/operations')
          && pagesForAllRounds.includes('analysis/bcase/investors')
        );
        const isCustomerAnalysisVisited = (
          pages.includes('ceo/analysis/market')
          || pages.includes('pd/analysis/market')
          || pages.includes('pm/analysis/market')
          || pages.includes('op/analysis/market')
          || pages.includes('fn/analysis/market')
        );
        const isPriorRoundVisited = currentRound === 1 ? true : (
          priorRoundPages.includes('analysis/team-reports/marketing-analysis/market-share-capture')
          && priorRoundPages.includes('analysis/team-reports/marketing-analysis/customer-survey')
          && priorRoundPages.includes('analysis/team-reports/marketing-analysis/marketing-selling-price')
          && priorRoundPages.includes('analysis/team-reports/marketing-analysis/marketing-awareness')
          && priorRoundPages.includes('analysis/team-reports/operational-analysis/operational-analysis-unit-costs')
          && priorRoundPages.includes('analysis/team-reports/operational-analysis/operational-analysis-unit-costs-breakdown')
          && priorRoundPages.includes('analysis/team-reports/operational-analysis/operational-analysis-inventory-management')
          && priorRoundPages.includes('analysis/team-reports/financing-analysis/financing-analysis-capital-structure')
          && priorRoundPages.includes('analysis/team-reports/financing-analysis/financing-analysis-valuation')
          && priorRoundPages.includes('analysis/team-reports/financing-analysis/financing-analysis-shares')
        );
        const isTriviaDone = pages.includes('round-trivia/trivia/done');

        const userGoals = goalsTargets.results
          .find(i => (
            Number(i.course) === courseId
            && Number(i.round) === roundId
            && Number(i.team) === teamId
            && Number(i.user) === userId
          ));
        const isGoalsSubmitted = !!userGoals;

        const user = Auth.getUser();
        const userRole = roleToUrl(user.role);

        const decisionsHistory = res[2].body;
        decisionsHistory.sort((a, b) => {
          const dateA = new Date(a.requested_at);
          const dateB = new Date(b.requested_at);

          return dateB - dateA;
        });

        const pdPath = decisionsHistory.findIndex(i => (
          i.path === '/api/teams/submit_development/'
          && i.response
          && i.response.success === true
        ));
        const actionsAfterPD = pdPath > -1 ? decisionsHistory.slice(0, pdPath).filter(i => (
          i.path.startsWith('/api/team/products')
        )) : [];
        const pdSubmitted = pdPath > -1 && actionsAfterPD.length === 0;

        const pmPath = decisionsHistory.findIndex(i => (
          i.path === '/api/teams/submit_marketing/'
          && i.response
          && i.response.success === true
        ));
        const actionsAfterPM = pmPath > -1 ? decisionsHistory.slice(0, pmPath).filter(i => (
          i.path.startsWith('/api/team/price_forecasts')
          || i.path.startsWith('/api/team/promos')
          || i.path.startsWith('/api/team/sales')
        )) : [];
        const pmSubmitted = pmPath > -1 && actionsAfterPM.length === 0;

        const opPath = decisionsHistory.findIndex(i => (
          i.path === '/api/teams/submit_operations/'
          && i.response
          && i.response.success === true
        ));
        const actionsAfterOP = opPath > -1 ? decisionsHistory.slice(0, opPath).filter(i => (
          i.path.startsWith('/api/team/factories')
          || i.path.startsWith('/api/team/machines')
          || i.path.startsWith('/api/team/product_manufactures')
          || i.path.startsWith('/api/v2/distributions/team-centers')
        )) : [];
        const opSubmitted = opPath > -1 && actionsAfterOP.length === 0;

        const fnPath = decisionsHistory.findIndex(i => (
          i.path === '/api/teams/submit_finance/'
          && i.response
          && i.response.success === true
        ));
        const actionsAfterFN = fnPath > -1 ? decisionsHistory.slice(0, fnPath).filter(i => (
          i.path.startsWith('/api/team/debts')
          || i.path.startsWith('/api/team/equities')
          || i.path.startsWith('/api/team/stock_repurchased')
          || i.path.startsWith('/api/team/dividends_payment')
          || i.path.startsWith('/api/team/debt_repayments')
        )) : [];
        const fnSubmitted = fnPath > -1 && actionsAfterFN.length === 0;

        this.setState({
          loading: false,
          isBusinessCaseVisited,
          isCustomerAnalysisVisited,
          isPriorRoundVisited,
          isGoalsSubmitted,
          isTriviaDone,
          userRole,
          pdSubmitted,
          pmSubmitted,
          opSubmitted,
          fnSubmitted,
          triviaCourseAvailable
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  render() {
    const { currentRound } = this.props;
    const {
      loading,
      isBusinessCaseVisited,
      isCustomerAnalysisVisited,
      isPriorRoundVisited,
      isGoalsSubmitted,
      isTriviaDone,
      pdSubmitted,
      pmSubmitted,
      opSubmitted,
      fnSubmitted,
      triviaCourseAvailable
    } = this.state;

    const showMarketResearch = (
      !isBusinessCaseVisited
      || !isCustomerAnalysisVisited
      || !isPriorRoundVisited
    );
    const showGoalsAndTargets = (
      !showMarketResearch
      && !isGoalsSubmitted
    );
    const showTrivia = (
      !showMarketResearch
      && !showGoalsAndTargets
      && !isTriviaDone
    );
    const showSubmitDecisions = (
      !showMarketResearch
      && !showGoalsAndTargets
      && !showTrivia
    );

    const showPriorRound = false;

    return loading ? (
      <Wrapper>
        <Loader type="ball-scale-ripple" active />
      </Wrapper>
    ) : (
      <Wrapper>
        <Container>
          <Text1>Next Steps</Text1>
          <Text2>Complete Round Challenges</Text2>
          {showMarketResearch && (
            <BigGoal>
              <Image>
                <img src={Image1} alt="" />
              </Image>
              <BigGoalTitle>
                <BigGoalTitleNum>1</BigGoalTitleNum>
                <div><a href={`/analysis/bcase/executive-summary?round=${currentRound}`}>Research</a></div>
              </BigGoalTitle>
              <BigGoalDescription>
                Understand the opportunity to help your team
                make informed decisions.
              </BigGoalDescription>
              <CheckboxesRow>
                <Checkbox>Viewed</Checkbox>
                <Checkbox>
                  <img src={isBusinessCaseVisited ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <div><a href={`/analysis/bcase/executive-summary?round=${currentRound}`}>Business Case</a></div>
                </Checkbox>
                <Checkbox>
                  <img src={isCustomerAnalysisVisited ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <div><a href={`/ceo/analysis/market?round=${currentRound}`}>Customer Analysis</a></div>
                </Checkbox>
                {currentRound > 1 && (
                  <Checkbox>
                    <img src={isPriorRoundVisited ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                    <div><a href={`/analysis/team-reports?round=${currentRound}`}>Prior Round Report</a></div>
                  </Checkbox>
                )}
              </CheckboxesRow>
            </BigGoal>
          )}
          {showMarketResearch && (
            <SmallGoals>
              {
                currentRound > 1 &&
                <SmallGoal>
                  <img src={isGoalsSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <SmallGoalTitle>
                    <SmallGoalTitleNum>2</SmallGoalTitleNum>
                    <div><a href={`/analysis/team-reports?round=${currentRound}`}>Read Prior Round Report</a></div>
                  </SmallGoalTitle>
                  <SmallGoalDescription>
                    Analyze and improve your decisions with concrete team reports.
                  </SmallGoalDescription>
                </SmallGoal>
              }
              <SmallGoal>
                <SmallGoalTitle>
                  <SmallGoalTitleNum>{currentRound > 1 ? 3 : 2}</SmallGoalTitleNum>
                  <div><a href={`/goals-and-targets?round=${currentRound}`}>View Goals &amp; Targets</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  View specific, attainable goals that drive
                  your round decisions.
                </SmallGoalDescription>
              </SmallGoal>
              {
                triviaCourseAvailable !== 0 &&
                <SmallGoal>
                  <img src={isTriviaDone ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <SmallGoalTitle>
                    <SmallGoalTitleNum>{currentRound > 1 ? 4 : 3}</SmallGoalTitleNum>
                    <div><a href={`/round-trivia?round=${currentRound}`}>Take the Trivia</a></div>
                  </SmallGoalTitle>
                  <SmallGoalDescription>
                    Assess how prepared you are for this round.
                  </SmallGoalDescription>
                </SmallGoal>
              }
              <SmallGoal>
                <SmallGoalTitle>
                  <SmallGoalTitleNum>{currentRound > 1 ? (4 + triviaCourseAvailable) : (3 + triviaCourseAvailable)}</SmallGoalTitleNum>
                  <div><a href={`/decisions/ceo?round=${currentRound}`}>Make &amp; Submit Decisions</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  Reach out and collaborate with your teammates
                  to make and submit decisions.
                </SmallGoalDescription>
              </SmallGoal>
            </SmallGoals>
          )}

          {showPriorRound && (
            <BigGoal>
              <Image>
                <img src={Image5} alt="" />
              </Image>
              <BigGoalTitle>
                <BigGoalTitleNum>2</BigGoalTitleNum>
                <div><a href={`/analysis/team-reports?round=${currentRound}`}>Read Prior Round Report</a></div>
              </BigGoalTitle>
              <BigGoalDescription>
                Analyze and improve your decisions with concrete team reports.
              </BigGoalDescription>
              <CheckboxesRow>
                <Checkbox>Submited</Checkbox>
                <Checkbox>
                  <img src={SmallCheckbox} alt="small checkbox" />
                  <div>Decisions (5)</div>
                </Checkbox>
              </CheckboxesRow>
            </BigGoal>
          )}
          {showPriorRound && (
            <SmallGoals>
              <SmallGoal>
                <SmallGoalTitle>
                  <SmallGoalTitleNum>3</SmallGoalTitleNum>
                  <div><a href={`/goals-and-targets?round=${currentRound}`}>View Goals &amp; Targets</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  View specific, attainable goals that drive
                  your round decisions.
                </SmallGoalDescription>
              </SmallGoal>
              {
                triviaCourseAvailable !== 0 &&
                <SmallGoal>
                  <img src={SmallCheckboxActive} alt="small checkbox" />
                  <SmallGoalTitle>
                    <SmallGoalTitleNum>4</SmallGoalTitleNum>
                    <div><a href={`/round-trivia?round=${currentRound}`}>Take a Trivia</a></div>
                  </SmallGoalTitle>
                  <SmallGoalDescription>
                    Are you prepared for making new decisions?
                    Take a trivia to assess.
                  </SmallGoalDescription>
                </SmallGoal>
              }
              <SmallGoal>
                <SmallGoalTitle>
                  <SmallGoalTitleNum>{4 + triviaCourseAvailable}</SmallGoalTitleNum>
                  <div><a href={`/decisions/ceo?round=${currentRound}`}>Make &amp; Submit Decisions</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  Reach out and collaborate with your teammates
                  to make and submit decisions.
                </SmallGoalDescription>
              </SmallGoal>
              <SmallGoal isGreyed={true}>
                <img src={SmallCheckboxActive} alt="small checkbox" />
                <SmallGoalTitle>
                  <SmallGoalTitleNum>1</SmallGoalTitleNum>
                  <div><a href={`/analysis/bcase/executive-summary?round=${currentRound}`}>Research</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  Understand the image censor market opportunity and the customers.
                </SmallGoalDescription>
              </SmallGoal>
            </SmallGoals>
          )}

          {showGoalsAndTargets && (
            <BigGoal>
              <Image>
                <img src={Image2} alt="" />
              </Image>
              <BigGoalTitle>
                <BigGoalTitleNum>{currentRound > 1 ? 3 : 2}</BigGoalTitleNum>
                <div><a href={`/goals-and-targets?round=${currentRound}`}>View Goals &amp; Targets</a></div>
              </BigGoalTitle>
              <BigGoalDescription>
                View specific, attainable goals that drive your round decisions.
              </BigGoalDescription>
              <CheckboxesRow>
                {/* <Checkbox>Submitted</Checkbox>
                <Checkbox>
                  <img src={isGoalsSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <div><a href={`/goals-and-targets?round=${currentRound}`}>Goals &amp; Targets</a></div>
                </Checkbox> */}
              </CheckboxesRow>
            </BigGoal>
          )}
          {showGoalsAndTargets && (
            <SmallGoals>
              {
                triviaCourseAvailable !== 0 &&
                <SmallGoal>
                  <img src={isTriviaDone ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <SmallGoalTitle>
                    <SmallGoalTitleNum>{currentRound > 1 ? 4 : 3}</SmallGoalTitleNum>
                    <div><a href={`/round-trivia?round=${currentRound}`}>Take the Trivia</a></div>
                  </SmallGoalTitle>
                  <SmallGoalDescription>
                    Assess how prepared you are for this round.
                  </SmallGoalDescription>
                </SmallGoal>
              }
              <SmallGoal>
                <SmallGoalTitle>
                  <SmallGoalTitleNum>{currentRound > 1 ? (4 + triviaCourseAvailable) : (3 + triviaCourseAvailable)}</SmallGoalTitleNum>
                  <div><a href={`/decisions/ceo?round=${currentRound}`}>Make &amp; Submit Decisions</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  Reach out and collaborate with your teammates
                  to make and submit decisions.
                </SmallGoalDescription>
              </SmallGoal>
              <SmallGoal isGreyed={true}>
                <img src={SmallCheckboxActive} alt="small checkbox" />
                <SmallGoalTitle>
                  <SmallGoalTitleNum>1</SmallGoalTitleNum>
                  <div><a href={`/analysis/bcase/executive-summary?round=${currentRound}`}>Research</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  Understand the image censor market opportunity and the customers.
                </SmallGoalDescription>
              </SmallGoal>
              {
                currentRound > 1 &&
                <SmallGoal isGreyed={true}>
                  <img src={isGoalsSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <SmallGoalTitle>
                    <SmallGoalTitleNum>2</SmallGoalTitleNum>
                    <div><a href={`/analysis/team-reports?round=${currentRound}`}>Read Prior Round Report</a></div>
                  </SmallGoalTitle>
                  <SmallGoalDescription>
                    Analyze and improve your decisions with concrete team reports.
                  </SmallGoalDescription>
                </SmallGoal>
              }
            </SmallGoals>
          )}
          {(showTrivia && triviaCourseAvailable !== 0) && (
            <BigGoal>
              <Image>
                <img src={Image3} alt="" />
              </Image>
              <BigGoalTitle>
                <BigGoalTitleNum>{currentRound > 1 ? 4 : 3}</BigGoalTitleNum>
                <div>Take a Trivia</div>
              </BigGoalTitle>
              <BigGoalDescription>
                Are you prepared for making new decisions? Assess
                with a few questions.
              </BigGoalDescription>
              <CheckboxesRow>
                <Checkbox>Completed</Checkbox>
                <Checkbox>
                  <img src={isTriviaDone ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <div><a href={`/round-trivia?round=${currentRound}`}>Trivia</a></div>
                </Checkbox>
              </CheckboxesRow>
            </BigGoal>
          )}
          {showTrivia && (
            <SmallGoals>
              <SmallGoal>
                <SmallGoalTitle>
                  <SmallGoalTitleNum>{currentRound > 1 ? (4 + triviaCourseAvailable) : (3 + triviaCourseAvailable)}</SmallGoalTitleNum>
                  <div><a href={`/decisions/ceo?round=${currentRound}`}>Make &amp; Submit Decisions</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  Reach out and collaborate with your teammates
                  to make and submit decisions.
                </SmallGoalDescription>
              </SmallGoal>
              <SmallGoal isGreyed={true}>
                <img src={SmallCheckboxActive} alt="small checkbox" />
                <SmallGoalTitle>
                  <SmallGoalTitleNum>1</SmallGoalTitleNum>
                  <div><a href={`/analysis/bcase/executive-summary?round=${currentRound}`}>Research</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  Understand the image censor market opportunity and the customers.
                </SmallGoalDescription>
              </SmallGoal>
              {
                currentRound > 1 &&
                <SmallGoal isGreyed={true}>
                  <img src={isGoalsSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <SmallGoalTitle>
                    <SmallGoalTitleNum>2</SmallGoalTitleNum>
                    <div><a href={`/analysis/team-reports?round=${currentRound}`}>Read Prior Round Report</a></div>
                  </SmallGoalTitle>
                  <SmallGoalDescription>
                    Analyze and improve your decisions with concrete team reports.
                  </SmallGoalDescription>
                </SmallGoal>
              }
              <SmallGoal isGreyed={true}>
                <SmallGoalTitle>
                  <SmallGoalTitleNum>{currentRound > 1 ? 3 : 2}</SmallGoalTitleNum>
                  <div><a href={`/goals-and-targets?round=${currentRound}`}>View Goals &amp; Targets</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  View specific, attainable goals that drive
                  your round decisions.
                </SmallGoalDescription>
              </SmallGoal>
            </SmallGoals>
          )}
          {showSubmitDecisions && (
            <BigGoal>
              <Image>
                <img src={Image4} alt="" />
              </Image>
              <BigGoalTitle>
                <BigGoalTitleNum>{currentRound > 1 ? (4 + triviaCourseAvailable) : (3 + triviaCourseAvailable)}</BigGoalTitleNum>
                <div><a href={`/decisions/ceo?round=${currentRound}`}>Make &amp; Submit Decisions</a></div>
              </BigGoalTitle>
              <BigGoalDescription>
                Gather information, evaluate possible resolutions
                and make team choices.
              </BigGoalDescription>
              <CheckboxesRow>
                <Checkbox>Submitted</Checkbox>
                <Checkbox>
                  <img src={pdSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <div><a href={`/decisions/product-development?round=${currentRound}`}>Product</a></div>
                </Checkbox>
                <Checkbox>
                  <img src={pmSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <div><a href={`/decisions/product-marketing?round=${currentRound}`}>Marketing</a></div>
                </Checkbox>
                <Checkbox>
                  <img src={opSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <div><a href={`/decisions/operations?round=${currentRound}`}>Operations</a></div>
                </Checkbox>
                <Checkbox>
                  <img src={fnSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <div><a href={`/decisions/finance?round=${currentRound}`}>Finance</a></div>
                </Checkbox>
              </CheckboxesRow>
            </BigGoal>
          )}
          {showSubmitDecisions && (
            <SmallGoals>
              <SmallGoal isGreyed={true}>
                <img src={SmallCheckboxActive} alt="small checkbox" />
                <SmallGoalTitle>
                  <SmallGoalTitleNum>1</SmallGoalTitleNum>
                  <div><a href={`/analysis/bcase/executive-summary?round=${currentRound}`}>Research</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  Understand the image censor market opportunity and the customers.
                </SmallGoalDescription>
              </SmallGoal>
              {
                currentRound > 1 &&
                <SmallGoal isGreyed={true}>
                  <img src={isGoalsSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <SmallGoalTitle>
                    <SmallGoalTitleNum>2</SmallGoalTitleNum>
                    <div><a href={`/analysis/team-reports?round=${currentRound}`}>Read Prior Round Report</a></div>
                  </SmallGoalTitle>
                  <SmallGoalDescription>
                    Analyze and improve your decisions with concrete team reports.
                  </SmallGoalDescription>
                </SmallGoal>
              }
              <SmallGoal isGreyed={true}>
                <SmallGoalTitle>
                  <SmallGoalTitleNum>{currentRound > 1 ? 3 : 2}</SmallGoalTitleNum>
                  <div><a href={`/goals-and-targets?round=${currentRound}`}>View Goals &amp; Targets</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  View specific, attainable goals that drive
                  your round decisions.
                </SmallGoalDescription>
              </SmallGoal>
              {
                triviaCourseAvailable !== 0 &&
                <SmallGoal isGreyed={true}>
                  <img src={SmallCheckboxActive} alt="small checkbox" />
                  <SmallGoalTitle>
                    <SmallGoalTitleNum>{currentRound > 1 ? 4 : 3}</SmallGoalTitleNum>
                    <div>Take a Trivia</div>
                  </SmallGoalTitle>
                  <SmallGoalDescription>
                    Are you prepared for making new decisions?
                    Take a trivia to assess.
                  </SmallGoalDescription>
                </SmallGoal>
              }
            </SmallGoals>
          )}
        </Container>
      </Wrapper>
    );
  }

}

export default NextStepsPage;



// WEBPACK FOOTER //
// ./src/components/onboarding/NextSteps.js